/* eslint-disable sonarjs/cognitive-complexity */
import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { DropMenuEl } from 'common/components/drop-menu';
import { ItemsMenuEl } from 'common/components/items-menu';
import { InputEl } from 'common/components/input';
import { SelectEl } from 'common/components/select';
import { SvgIconEl } from 'common/components/svg-icon';
import { TextHighlightEl } from 'common/components/text-highlight';
import { OptionsType } from './types';

function isButtonOption(option) {
  return option.type === OptionsType.Button;
}

function isSelectOption(option) {
  return option.type === OptionsType.Select;
}

function isSidebarOption(option) {
  return option.type === OptionsType.Sidebar;
}

export function template() {
  const {
    searchInputEl,
    searchText,
    showDropdown,
    slidOutSectionIdx
  } = this.state;

  const ActionRenderer = _ref => {
    let {
      item
    } = _ref;
    return jsx(SvgIconEl, {
      attrs: {
        icon: "x"
      },
      on: {
        click: ev => this.helpers.handleClickRemove(ev, item)
      }
    });
  };

  return jsx("div", {
    sel: '.options-bar'
  }, jsx("div", {
    sel: '.options-bar-top'
  }, jsx(InputEl, {
    sel: '.search-input',
    attrs: {
      elref: "optionsBarSearchInput",
      icon: "search",
      placeholder: this.attr("search-placeholder"),
      'show-clear': true,
      value: searchText
    },
    props: {
      maxLength: 50,
      value: searchText
    },
    hook: {
      insert: this.helpers.inputInserted
    },
    on: {
      clear: () => this.helpers.handleUpdateInput(this.helpers.DEFAULT_INPUT_STRING),
      click: this.helpers.handleInputClick,
      keydown: this.helpers.handleKeydown,
      input: ev => this.helpers.handleUpdateInput(ev.target.value)
    }
  }), jsx(DropMenuEl, {
    sel: '.options-bar-input-dropdown',
    attrs: {
      open: showDropdown && searchText === this.helpers.DEFAULT_INPUT_STRING
    },
    class: {
      shortened: !this.helpers.isNil(slidOutSectionIdx)
    },
    on: {
      change: ev => this.helpers.handleInputDropdownChange(ev.detail)
    }
  }, jsx(ItemsMenuEl, {
    attrs: {
      'empty-message': this.helpers.getEmptyState()
    },
    props: {
      keydownProxyEl: showDropdown && searchInputEl,
      sections: [{
        actionsRenderer: item => ActionRenderer({
          item
        }),
        items: this.helpers.getSearchedHistory().slice(0, 5)
      }]
    },
    on: {
      clickItem: _ref2 => {
        let {
          detail
        } = _ref2;
        return this.helpers.handleSearchItemSelection(detail.item.value);
      }
    }
  })), jsx("div", {
    sel: '.options'
  }, this.attr("options").map((optionConfig, idx) => !optionConfig.hidden ? (() => {
    // sidebar and select have sections but button doesn't
    const totalCount = !isButtonOption(optionConfig) && optionConfig.sections && this.helpers.getTotalNumberOfSelectedItems(optionConfig.sections);
    return jsx("div", {
      sel: '.option-container',
      class: {
        'has-count': isSidebarOption(optionConfig) && optionConfig.showNumItems
      },
      style: {
        'min-width': "".concat(this.helpers.isNil(slidOutSectionIdx) ? 0 : optionConfig.menuWidth, "px")
      }
    }, isButtonOption(optionConfig) ? jsx(ButtonEl, {
      attrs: {
        elref: "optionButton",
        icon: optionConfig.icon,
        size: ButtonSize.Large,
        theme: ButtonTheme.Tertiary,
        disabled: optionConfig.disabled
      },
      on: {
        click: () => this.helpers.handleButtonClick(optionConfig)
      }
    }, optionConfig.name) : isSidebarOption(optionConfig) ? jsx(ButtonEl, {
      attrs: {
        elref: "optionButtonSlideOut",
        icon: optionConfig.icon,
        size: ButtonSize.Large,
        theme: ButtonTheme.Tertiary
      },
      on: {
        click: () => this.helpers.handleSlideOut(idx)
      }
    }, optionConfig.name, optionConfig.showNumItems && totalCount ? jsx(TextHighlightEl, {
      sel: '.option-list-selected-count',
      attrs: {
        length: "wide",
        text: totalCount.toString()
      }
    }) : null) : isSelectOption(optionConfig) ? jsx(SelectEl, {
      attrs: {
        'menu-width': optionConfig.menuWidth || 140,
        'menu-height': 500,
        sections: optionConfig.sections,
        icon: {
          leftIcon: optionConfig.icon,
          rightIcon: "status-light"
        },
        elref: "optionsSelector",
        'selected-option': optionConfig.name,
        'no-button-truncate': true,
        multiple: optionConfig.multiple,
        theme: "tertiary",
        size: "large"
      },
      on: {
        change: this.helpers.handleClickItemFromOption
      }
    }, optionConfig.showNumItems && totalCount ? jsx("div", {
      sel: '.options-list-selected-count-container',
      attrs: {
        slot: "button-suffix"
      }
    }, jsx(TextHighlightEl, {
      sel: '.option-list-selected-count',
      attrs: {
        length: "wide",
        text: totalCount.toString()
      }
    })) : null) : null);
  })() : null), !this.helpers.isNil(slidOutSectionIdx) ? this.helpers.getTotalNumberOfSelectedItems(this.attr("options")[slidOutSectionIdx].sections) > 0 ? jsx(ButtonEl, {
    attrs: {
      size: ButtonSize.Large,
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: this.helpers.resetSectionsSlideOut
    }
  }, "Clear all") : jsx("div", {
    sel: '.option-bar-slide-out-clear-all-placeholder'
  }) : null)), !this.helpers.isNil(slidOutSectionIdx) ? jsx("div", {
    sel: '.option-bar-slide-out'
  }, jsx("div", {
    sel: '.section-divider'
  }), jsx(ItemsMenuEl, {
    attrs: {
      elref: "optionsBarSlideOutItems",
      multiple: true,
      sections: this.attr("options")[slidOutSectionIdx].sections
    },
    on: {
      clickItem: this.helpers.handleClickItemFromOption
    }
  })) : null);
}